export enum GameSelectionCategory {
  IMAGE = 'image',
  TEXT = 'text'
}
